import { Link } from 'react-router-dom';
import { allMovies, articles } from '@/mocks/movies';
import { useState } from 'react';

type TabType = 'movies' | 'articles';

export default function LatestContent() {
  const [activeTab, setActiveTab] = useState<TabType>('movies');
  const recentMovies = allMovies.slice(0, 6);
  const recentArticles = articles.slice(0, 4);

  return (
    <section className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
            最新内容
          </h2>
          <div className="flex items-center bg-background-100 rounded-full p-1">
            <button
              onClick={() => setActiveTab('movies')}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap ${
                activeTab === 'movies'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              最新影片
            </button>
            <button
              onClick={() => setActiveTab('articles')}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap ${
                activeTab === 'articles'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              最新影评
            </button>
          </div>
        </div>

        {activeTab === 'movies' && (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {recentMovies.map((movie) => (
              <Link
                key={movie.id}
                to={`/article/${movie.id}`}
                className="group bg-background-100 rounded-xl overflow-hidden transition-all duration-300 hover:bg-background-200"
              >
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={movie.imageUrl}
                    alt={movie.title}
                    title={`${movie.title} - ${movie.channel}`}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute top-2 right-2">
                    <span className="px-1.5 py-0.5 bg-background-950/70 text-background-50 text-xs font-medium rounded whitespace-nowrap">
                      {movie.rating}
                    </span>
                  </div>
                </div>
                <div className="p-3">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors line-clamp-1">
                    {movie.title}
                  </h3>
                  <div className="flex items-center gap-2 text-xs text-foreground-500">
                    <span>{movie.year}</span>
                    <span>·</span>
                    <span className="line-clamp-1">{movie.channel}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}

        {activeTab === 'articles' && (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {recentArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group flex gap-4 bg-background-100 rounded-xl p-4 transition-all duration-300 hover:bg-background-200"
              >
                <div className="w-32 h-20 md:w-40 md:h-24 rounded-lg overflow-hidden flex-shrink-0">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 mb-2">{article.summary}</p>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span>{article.channel}</span>
                    <span>·</span>
                    <span>{article.views.toLocaleString()} 阅读</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}